// @flow

export type SerializedBarcodeQuery = {
  upc: string,
  product_number: string,
  variation_code: string,
  material_number: string,
};

export type BarcodeQuery = {
  upc: string,
  productNumber: string,
  variationCode: string,
  materialNumber: string,
};

// eslint-disable-next-line import/prefer-default-export
export const deserialized = ({
  upc,
  /* eslint-disable camelcase */
  product_number,
  variation_code,
  material_number,
}: /* eslint-enable camelcase */
SerializedBarcodeQuery): BarcodeQuery => ({
  upc,
  productNumber: product_number,
  variationCode: variation_code,
  materialNumber: material_number,
});
